import $ from "jquery";
import app, { vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";

// [productsContainer]
vuwer.add("productsContainer", {
	vuwType: "colony",
	selector: "#products_container",
	
	// ** for TyrellModule **
	module: {
		app,
		dataKey: "products",
		// 取得条件
		getFilter: {
			// // 取得項目（未指定や空の配列の場合は全て取得）
			// getParams: [],
			// // 除外項目
			// kickParams: [],
			// 取得条件 ※SQLのWHEREに相当
			// conditions: []
		},
/*
		// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）※未指定の場合は"dateUpd"
		pkGroupByDate: "dateUpd",
		
		// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
		byDateFormat: "YYYY-MM",
		
		// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
		itemFilter(i, item) {
		},
*/
		
		// 設定情報の上書き
		configOverride: {}
	},
	
	// ** for VuwColony **
	// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
	articleTemplate: "",
	
	// ページャーの表示・非表示
	showPager: false,
	
	// // ページャーから除外するクエリ文字列
	// excludeQueryFromPager: ["post"],
	
	/*----------------
	* 記事表示用の関数（未指定の場合はテンプレートから生成）
	* @param item [object] １記事分のデータオブジェクト
	* @param config [object] 設定オブジェクト
	* @param $artcl [$] テンプレートから生成された$オブジェクト
	* @param module [TyrellModule] データ取得用モジュール
	* @return (falseを返すと非表示)
	*/
	initArticle(item, config, $article, module) {
		const $content = $article.children(".content");
		const $body = $content.children(".section-body");
		$body.children(".type-file").each((i, elm) => {
			const { className } = elm;
			const mediaType = className.split(" ").pop().split("-").pop();
			
			const $container = $("<div/>").addClass("media-container").attr({
				"data-media": mediaType
			});
			
			const $elm = $(elm);
			$elm.wrap($container);
			
			$elm.children(".caption").insertAfter($elm);
			
			if(mediaType === "video") {
				$elm.children("video").attr("controlslist", "nodownload");
			}
		});
		
		if( Array.isArray(item.embedVideos) ) {
			const pi = config.dataParams.embedVideos;
			$.fn.append.apply(
				$body,
				item.embedVideos.map((data, i) => {
					const $container = $("<div/>").addClass("media-container").attr({
						"data-media": "video"
					});
					
					const { tag, caption } = data;
					!!tag && $("<div/>").addClass(
						`echoed-data type-${pi.inpType}`
					).attr({
						"data-index": i,
						"data-key": "embedVideos"
					}).append(
						$.parseHTML(tag)
					).appendTo($container);
					
					!!caption && $("<span/>").addClass("caption").text(
						caption
					).appendTo($container);
					
					return $container;
				})
			);
		}
	},
	
	async onReadyLast($self) {
		if(!$self) {
			return false;
		}
		
		await this.initList();
		
		const $imageHr = this.$self.nextAll(".image-hr");
		
		if($imageHr.length) {
			const children = this.getChildren();
			const targetVuw = children.get(2);
			if(targetVuw && targetVuw.$self) {
				$imageHr.eq(0).insertBefore(
					targetVuw.$self
				);
				
				if($imageHr.length > 1 && children.length > 3) {
					$imageHr.eq(1).insertAfter(
						targetVuw.$self
					);
				}
			} else
			if($imageHr.length > 1) {
				$imageHr.eq(1).remove();
			}
		}
	}
}, function() {
	// appから直接アクセス可能にする
	const dataKey = this.module.getDataKey();
	app[dataKey] = this.module;
});
